import React, { useEffect } from 'react'
import { StyleSheet, View } from 'react-native'
import { Redirect, useLocalSearchParams, useRouter } from 'expo-router'
import { create } from 'zustand'

import { PaddedLayout } from '../../components/layouts/PaddedLayout'
import { ScreenTitle } from '../../components/ScreenTitle/ScreenTitle'
import { SecondaryButton } from '../../components/SecondaryButton/SecondaryButton'
import { Results } from './components/Results'
import { IResults } from './interfaces/results.interface'
import { fontFamily } from '../../theme/fontFamily'

export const useMiniGameResultsStore = create<IResults | undefined>(() => undefined)

export const FinalScreen = () => {
  const router = useRouter()
  const { gameName } = useLocalSearchParams<{ gameName: string }>()
  const miniGameResults = useMiniGameResultsStore()

  if (!miniGameResults) {
    return <Redirect href={'/minigames/lobby'} />
  }

  useEffect(() => {
    return () => {
      useMiniGameResultsStore.setState(undefined)
    }
  }, [])

  return (
    <PaddedLayout>
      <View style={styles.container}>
        <ScreenTitle tx="miniGamesScreen.finalScreen.title" />

        <Results results={miniGameResults} />

        <SecondaryButton
          textProps={{
            tx: 'miniGamesScreen.finalScreen.playAgainButton',
            style: styles.button
          }}
          onPress={() => router.navigate(`/minigames/intro?gameName${gameName}`)}
        />
      </View>
    </PaddedLayout>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  button: {
    fontFamily: fontFamily.sfProDisplayBlackItalic,
    fontSize: 18,
    lineHeight: 21
  }
})
